// ** React Imports
import { ReactNode, useState } from 'react';

// ** Next Imports
import { useLocation, useNavigate } from 'react-router-dom';

// ** Types
import type { ACLObj, AppAbility } from 'src/configs/acl';

// ** Context Imports
import { AbilityContext } from 'src/materio/layouts/components/acl/Can';

// ** Config Import
import { buildAbilityFor } from 'src/configs/acl';

// ** Component Import
import NotAuthorized from 'src/pages/NotAuthorized';
import BlankLayout from 'src/materio/@core/layouts/BlankLayout';

// ** Hooks
import { useAuth } from 'src/hooks/useAuth';
import { ClaimType } from './RenderIf';

interface AclGuardProps {
    children: ReactNode;
    guestGuard: boolean;
    claimType: ClaimType;
}

const ClaimGuard = (props: AclGuardProps) => {
    // ** Props
    const { claimType, children, guestGuard } = props;

    // ** Hooks
    const auth = useAuth();
    const location = useLocation();

    // If guestGuard is true and user is not logged in or its an error page, render the page without checking access
    if (guestGuard || location.pathname === '/404' || location.pathname === '/500' || location.pathname === '/') {
        return <>{children}</>;
    }

    // Check if no claims are present
    if (claimType === ClaimType.None) {
        return <>{children}</>;
    }

    // Check the access of current user and render pages
    if (auth.user && (auth.user.isAdmin || auth.user.claims.some((c) => c.claim === claimType))) {
        return <>{children}</>;
    }

    // Render Not Authorized component if the current user has limited access
    return (
        <BlankLayout>
            <NotAuthorized />
        </BlankLayout>
    );
};

export default ClaimGuard;
